import tokenStore from '../TokenStore/tokenStore.js';
import joseUtils from './JoseUtils.js';
import tokenManagerHelper from './tokenManagerHelper.js';
import {oidcSettings} from '../SettingsManager/settingsManager.js';

var settings = {};
const validator = (function(setting) {
    settings = Object.assign({}, settings, setting);
    return validateAccessToken;
});

function validateAccessToken(token) {
    return new Promise((resolve, reject)=>{
        token = token ? token : tokenStore.getAccessToken();

        // Decode the JWT and grab the kid and alg property from the header.
        const jwt = joseUtils.parseJwt(token);
        const kid = jwt.header.kid;
        const alg = jwt.header.alg;
        oidcSettings(settings)
        .then((config)=>{
            const getJwkUri = config.jwkUri;
            const issuer = config.iss;
            const audience = config.aud;
            // retrieve the JWKS
            // Find the signing key in the filtered JWKS with a matching kid property.
            tokenManagerHelper.getSigningKey(getJwkUri, alg, kid)
            .then((key)=>{
                joseUtils.validateJwt(token, key, issuer, audience)
                .then(()=>{
                    resolve();
                },()=>{
                    reject();
                });
            });
        });
    });
}

export default validator;